var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6445 12.7662C21.9425 18.3639 17.141 22.6954 11.3222 22.6954C5.50341 22.6954 0.701885 18.3639 0 12.7662H6.56783C7.04473 12.7662 7.49007 12.5291 7.7546 12.1346L9.55739 9.44524L10.8662 17.2548C11.0788 18.5232 12.7426 18.8784 13.4599 17.8085L16.8399 12.7662H22.6445ZM0 9.92926C0.701885 4.33155 5.50341 0 11.3222 0C17.141 0 21.9425 4.33155 22.6445 9.92926H16.0766C15.5997 9.92926 15.1543 10.1663 14.8898 10.5609L13.087 13.2502L11.7783 5.44067C11.5656 4.17227 9.9018 3.81711 9.18457 4.88704L5.8045 9.92926H0Z",
    fill: "#321E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5);
export default __webpack_public_path__ + "static/media/Vector (5).11e7461d7ecc2577f0377bde3a533018.svg";
export { ForwardRef as ReactComponent };